module.exports = __webpack_public_path__ + "static/media/insert-card.427fc954.svg";